import * as yup from 'yup';

const defaultMessage = 'Campo obrigatório';
// eslint-disable-next-line
const minValueMessage = 'O valor deve ser maior ou igual a ${min}';

yup.setLocale({
  mixed: { required: defaultMessage, default: defaultMessage },
  string: { required: defaultMessage, default: defaultMessage },
  number: { required: defaultMessage, default: defaultMessage, min: minValueMessage },
  array: { required: defaultMessage, default: defaultMessage },
});

export default {
  schema: yup,
  validate: async (schema, values) => {
    try {
      await schema.validate(values, { abortEarly: false });
      return { status: true, data: {} };
    } catch (validationErrors) {
      return {
        status: false,
        data: validationErrors.inner.reduce(
          (allError, currentError) => ({
            ...allError,
            [currentError.path]: currentError.errors[0],
          }),
          {},
        ),
      };
    }
  },
};
